// extracted by mini-css-extract-plugin
export default {"NotEditableWidget":"NotEditableWidget_NotEditableWidget__HoLUY","title":"NotEditableWidget_title__urRYv","description":"NotEditableWidget_description__eaSlL"};